import { CollectorAdministratorApi, Configuration } from '.';
import * as ApiClients from './apis';
const config = new Configuration({
    basePath: '',
});
class ApiClient {
    constructor() {
        this.AcceptanceReport = new ApiClients.AcceptanceReportApi(config);
        this.Agreement = new ApiClients.AgreementApi(config);
        this.Calendar = new ApiClients.CalendarApi(config);
        this.Car = new ApiClients.CarApi(config);
        this.CarMake = new ApiClients.CarMakeApi(config);
        this.CollectorAdministrator = new CollectorAdministratorApi(config);
        this.Customer = new ApiClients.CustomerApi(config);
        this.CommonData = new ApiClients.CommonDataApi(config);
        this.Employee = new ApiClients.EmployeeApi(config);
        this.FileApi = new ApiClients.FileApi(config);
        this.GarageApi = new ApiClients.GarageApi(config);
        this.GarageSpotApi = new ApiClients.GarageSpotApi(config);
        this.GarageSpotAttributes = new ApiClients.GarageSpotAttributesApi(config);
        this.GarageSpotAttributeDefinition = new ApiClients.GarageSpotAttributeDefinitionApi(config);
        this.MaintenanceApi = new ApiClients.MaintenanceApi(config);
        this.PopulateData = new ApiClients.PopulateDataApi(config);
        this.Reservation = new ApiClients.ReservationApi(config);
        this.UserAuth = new ApiClients.UserAuthApi(config);
        this.ServiceAction = new ApiClients.ServiceActionApi(config);
    }
}
export const Api = new ApiClient();
